import {Directive, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {CALENDAR_TYPES, getDateParams, ICalendarDateParams, TCalendarCell, TIntCalendarInput} from "../../../shared";

@Directive({
  selector: '[intDateStateController]'
})
export class DateControllerStateDirective implements OnChanges, OnInit {

  @Input() date: TIntCalendarInput = null;

  @Input() type: keyof typeof CALENDAR_TYPES = 'single';

  @Output() onSelect = new EventEmitter<Date | [Date, Date]>();


  pluginStateForSelect: TIntCalendarInput = null;


  changePluginState$: BehaviorSubject<Date>
    = new BehaviorSubject<Date>(new Date());

  hoveredCellState$: BehaviorSubject<TCalendarCell | null> = new BehaviorSubject<TCalendarCell | null>(null);

  defaultPluginDateForNavigation: Date = new Date();

  get pluginDateStateForNavigation(): ICalendarDateParams {
    return getDateParams(this.changePluginState$.value);
  }

  get selected() {
    return this.pluginStateForSelect;
  }

  get isSingle() {
    return this.type === CALENDAR_TYPES.single;
  }

  get hoveredCellState() {
    return this.hoveredCellState$.value;
  }

  getSelectedDateState(date: TIntCalendarInput): Array<ICalendarDateParams | null> {
    return (date !== null ? date : [])
      .map((item: Date | null) => (item !== null) ? getDateParams(item) : item)
  }

  onlyValidSelectDates(): Array<ICalendarDateParams> {
    return this.getSelectedDateState(this.pluginStateForSelect)
      .filter((i) => {
        return Boolean(i);
      }) as Array<ICalendarDateParams>
  }

  ngOnInit() {

    const date = (this.date !== null && this.date[0] !== null)
      ? this.date[0]
      : this.defaultPluginDateForNavigation;

    this.pluginStateForSelect = this.date;

    this.changePluginState$.next(date);
  }

  ngOnChanges() {
    //this.changePluginState$.next(this.pluginStateForNavigation);
  }

  set(date: Date) {
    switch (this.type) {
      case 'single': {
        this.onSelect.emit(date);
        this.pluginStateForSelect = [date, null];
      }; break;
      case 'range': {
        const [v1, v2] = this.pluginStateForSelect !== null ? this.pluginStateForSelect : [null, null];
        if((v1 && v2) || (!v1 && !v2)) {
          this.pluginStateForSelect = [date, null];
          //this.onSelect.emit(date);
        }else if(v1 !== null && !v2) {
          const output = [v1, date];
          output.sort((d1, d2) => {
            return d1.getTime() - d2.getTime();
          })
          // @ts-ignore
          this.pluginStateForSelect = output;
          // @ts-ignore
          this.onSelect.emit(this.pluginStateForSelect);
        }
      }; break;
    }
  }

  setPluginDate(year?: number, month?: number, day?: number) {
    const {year: _year, month: _month, day: _day, } = this.pluginDateStateForNavigation;
    const date = new Date(
      year || _year,
      month !== undefined ? month : _month,
      day !== undefined ? day : _day
    );
    this.changePluginState$.next(date);
  }

  setPluginMonth(month: number) {
    const {day, year} = this.pluginDateStateForNavigation;
    const date = new Date(year, month, day);
    this.changePluginState$.next(date);
  }

  setPluginYear(year: number) {
    const {day, month} = this.pluginDateStateForNavigation;
    const date = new Date(year, month, day);
    this.changePluginState$.next(date);
  }

  setYM(month: number, year: number) {
    const {day} = this.pluginDateStateForNavigation;
    const date = new Date(year, month, day);
    this.changePluginState$.next(date);
  }

  hoveredDate(data: TCalendarCell | null) {
    this.hoveredCellState$.next(data);
  }
}
